import React, { FC } from 'react';
import { FastField, getIn } from 'formik';
import FieldWrapper from '../../../../../library/inputs/fieldWrapper/FieldWrapper';
import { FieldModel } from '../../../../../../models/form/field';
import { getFieldComponent } from './getFieldComponent';
import { getText } from '../../../../../../utilities/CultureUtilities';
import { useIntl } from 'react-intl';

interface Props {
  name: string;
  field: FieldModel;
  fieldProperties: any;
  size: number;
  readOnlyMode?: boolean;
}

const FormField: FC<Props> = ({ name, field, fieldProperties, size, readOnlyMode }: Props) => {
  const intl = useIntl();
  const shouldComponentUpdate = (nextProps, currentProps) => {
    if (
      nextProps.visible !== currentProps.visible ||
      nextProps.readOnly !== currentProps.readOnly ||
      nextProps.required !== currentProps.required ||
      nextProps.name !== currentProps.name ||
      getIn(nextProps.formik.values, currentProps.name) !== getIn(currentProps.formik.values, currentProps.name) ||
      getIn(nextProps.formik.errors, currentProps.name) !== getIn(currentProps.formik.errors, currentProps.name) ||
      getIn(nextProps.formik.touched, currentProps.name) !== getIn(currentProps.formik.touched, currentProps.name) ||
      Object.keys(currentProps).length !== Object.keys(nextProps).length ||
      nextProps.formik.isSubmitting !== currentProps.formik.isSubmitting
    ) {
      return true;
    } else {
      return false;
    }
  };
  return (
    <FastField
      required={field.required}
      visible={field.visible}
      name={name}
      shouldUpdate={shouldComponentUpdate}
      readOnly={readOnlyMode}
    >
      {(fieldProps) => {
        return (
          <FieldWrapper
            error={fieldProps.meta.error}
            touched={fieldProps.meta.touched}
            hiddenText={field.hiddenText}
            textColor={field.textColor}
            required={field.required}
            label={getText(field.text, intl.locale)}
            visible={field.visible}
            size={size}
          >
            {getFieldComponent(field, fieldProperties, fieldProps, intl.locale, readOnlyMode)}
          </FieldWrapper>
        );
      }}
    </FastField>
  );
};

export default FormField;
